import {Component, Input, OnInit} from '@angular/core';
import {History} from "../../../models/home/home.model";
import {OwlOptions} from "ngx-owl-carousel-o";

@Component({
  selector: 'app-slider-history',
  templateUrl: './slider-history.component.html',
  styleUrls: ['./slider-history.component.scss']
})
export class SliderHistoryComponent implements OnInit {

  @Input() histories: Array<History>;

  customOptions: OwlOptions = {
    loop: false,
    autoWidth: true,
    autoplay: false,
    autoplayHoverPause: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    mergeFit: false,
    navText: ["<", ">"],
    stagePadding: 50,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 3
      },
      740: {
        items: 3
      },
      940: {
        items: 3
      }
    },
    nav: true
  }
  constructor() { }

  ngOnInit(): void {
  }

}
